import { Typography, ListItemText } from '@mui/material';
import List from '../styled/List';
import ListItemIcon from '../styled/ListItemIcon';
import ListItem from '../styled/ListItem';

const Payments = () => (
  <>
    <Typography variant="h5" fontWeight="700" textTransform="none">
      8. Płatności.
    </Typography>
    <List>
      <ListItem>
        <ListItemIcon>8.1. </ListItemIcon>
        <ListItemText>
          W Serwisie przewidziana jest możliwość dokonywania płatności za
          pośrednictwem:
          <List>
            <ListItem>
              <ListItemIcon>a)</ListItemIcon>
              <ListItemText>
                kart płatniczych debetowych wydanych przez Visa lub MasterCard,
                w tym kart debetowych zagranicznych,
              </ListItemText>
            </ListItem>
            <ListItem>
              <ListItemIcon>b)</ListItemIcon>
              <ListItemText>
                płatności online, w tym Google Pay oraz Apple Pay,
              </ListItemText>
            </ListItem>
            <ListItem>
              <ListItemIcon>c)</ListItemIcon>
              <ListItemText> BLIK. </ListItemText>
            </ListItem>
            <ListItem>
              <ListItemIcon>d)</ListItemIcon>
              <ListItemText> przelewu bankowego. </ListItemText>
            </ListItem>
          </List>
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemIcon>8.2. </ListItemIcon>
        <ListItemText>
          Podmiotem świadczącym obsługę płatności online jest AUTOPAY S.A. z
          siedzibą w Sopocie, przy ulicy Powstańców Warszawy 6, 81–718 Sopot,
          zarejestrowana w Rejestrze Przedsiębiorców Krajowego Rejestru Sądowego
          prowadzonym przez Sąd Rejonowy Gdańsk – Północ w Gdańsku, VIII Wydział
          Gospodarczy Krajowego Rejestru Sądowego, pod numerem KRS 0000320590,
          NIP 5851351185, REGON 191781561, o kapitale zakładowym w wysokości
          2.205.500 zł wpłaconym w całości, nadzorowana przez Komisję Nadzoru
          Finansowego i wpisana do rejestru krajowych instytucji płatniczych pod
          numerem IP17/2013.
        </ListItemText>
      </ListItem>
      <ListItem>
        <ListItemIcon>8.3. </ListItemIcon>
        <ListItemText>
          Warunki świadczenia usług płatności online przez AUTOPAY S.A.
          określone są w regulaminie udostępnianym przed realizacją przez
          Użytkownika płatności.
        </ListItemText>
      </ListItem>
    </List>
  </>
);

export default Payments;
